import * as React from "react";

/**
 * Die Courté-Bildmarke (das „C" mit dem orangen Bogen) als Menü-Icon.
 *
 * Sie steht am Menüpunkt „CO intern" — und zwar genau deshalb, weil dieser
 * Bereich als einziger nicht die Kunden zeigt, sondern COURTÉ SELBST:
 * Lieferanten, Sponsoring, Mitgliedschaften, Direktionspartner. Ein
 * Fluent-Symbol daneben sagte „noch ein Bereich"; die Hausmarke sagt
 * „das sind wir".
 *
 * INLINE und nicht als `<img src="https://courte.com/…">`: Ein externer Aufruf
 * hinge an der Erreichbarkeit der Website, wäre ohne Netz leer und würde bei
 * jedem Seitenaufruf den Besuch an einen fremden Server melden. Die Datei ist
 * 1,5 kB — sie gehört ins Bündel.
 *
 * Quelle: https://courte.com/app/uploads/2023/07/courte-small-logo.svg
 * (abgerufen 11.09.2026, Pfade unverändert übernommen).
 */

/** Das Orange der Hausmarke. Dasselbe, das die Sidebar als Akzent führt. */
const COURTE_ORANGE = "#ffa615";

/**
 * Das „C" trägt in der Vorlage ein festes Weiß — gedacht für den dunklen
 * Briefkopf. Hier läuft es auf `currentColor`: So folgt es der Menüzeile
 * (ruhend, überfahren, aktiv) wie jedes andere Icon auch. Der orange Bogen
 * bleibt fest, er ist das Erkennungsmerkmal.
 */
export const CourteMarke: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg
    // Das Seitenverhältnis der Marke ist hochkant (41,8 × 69,6). Die Höhe
    // bestimmt die Größe, damit sie neben den 20×20-Symbolen auf derselben
    // Linie sitzt; die Breite ergibt sich daraus.
    height={size}
    width={size * (41.793 / 69.559)}
    viewBox="0 0 41.793 69.559"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <g transform="translate(-27.314 -6.995)">
      <path
        d="M73.248,23.4a14.781,14.781,0,0,1-6.565-1.569l-.445-.219.508-1.963.6.166a17.037,17.037,0,0,0,4.426.717,9.984,9.984,0,0,0,3.742-.778A13.7,13.7,0,0,0,79.6,17.313a5.483,5.483,0,0,1-.989-.6,5.755,5.755,0,0,1-2.267-3.593,5.061,5.061,0,0,1,1.109-4,5.354,5.354,0,0,1,3.6-2.068,5.92,5.92,0,0,1,.8-.056,5.079,5.079,0,0,1,3.176,1.1,5.235,5.235,0,0,1,2.1,4.375,8.632,8.632,0,0,1-2.083,5.265,14.214,14.214,0,0,1-5.185,4.078A14.756,14.756,0,0,1,73.411,23.4Z"
        transform="translate(-18.026)"
        fill={COURTE_ORANGE}
      />
      <path
        d="M50.691,95.083c-7.287,0-13.095-2.206-17.261-6.555a22.741,22.741,0,0,1-6.116-16.24A27.815,27.815,0,0,1,29,62.851a24.48,24.48,0,0,1,4.631-8,22,22,0,0,1,8.126-5.835A27.406,27.406,0,0,1,52.281,47c5.243,0,9.424,1.2,12.429,3.581a6.619,6.619,0,0,1,2.879,5.148,4.592,4.592,0,0,1-1.28,3.284,4.286,4.286,0,0,1-3.147,1.3c-2.582,0-4.491-1.837-5.674-5.46a19.48,19.48,0,0,0-1.171-3.075,3.718,3.718,0,0,0-1.109-1.3,5.974,5.974,0,0,0-3.666-1.1,9.745,9.745,0,0,0-5.451,1.652,14.278,14.278,0,0,0-3.816,3.715,23.192,23.192,0,0,0-2.736,5.637,31.52,31.52,0,0,0-1.823,10.3,25.474,25.474,0,0,0,1.658,9.019,21.172,21.172,0,0,0,4.485,7.329A13.826,13.826,0,0,0,54.14,91.636a11.1,11.1,0,0,0,8.015-3.068,16.272,16.272,0,0,0,3.1-5.309l.216-.537,2.179.756-.188.57c-1.282,3.873-3.276,6.712-5.927,8.439-2.636,1.72-6.284,2.593-10.84,2.6Z"
        transform="translate(0 -18.529)"
        fill="currentColor"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

export default CourteMarke;
